<template>
  <div v-if="isAuthenticated && orgId && orgEnsuredState" class="dashboard">
    <SideNavigation />
    <div class="main-content"></div>
  </div>
  <LoadingIndicator v-else class="loading-spinner" />
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import SideNavigation from '~/components/dashboard/SideNavigation';
import LoadingIndicator from '~/components/common/LoadingIndicator';
import { getOrgId } from '~/utils/auth-claims';

export default {
  name: 'DashboardLayout',

  components: {
    LoadingIndicator,
    SideNavigation,
  },
  setup() {
    const { isAuthenticated, user } = useAuth0();
    const store = useStore();
    const orgEnsuredState = computed(() => store.state.authStore.orgEnsuredState);
    // ARP-3442: the organization rides as a bridge claim for a legacy organization and as
    // a governance claim otherwise; the native org_id is neither.
    const orgId = computed(() => getOrgId(user.value));

    return {
      isAuthenticated,
      orgEnsuredState,
      orgId,
    };
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  @include bb-regular-text-styles('default');
  font-family: 'DM Sans', 'Arial', sans-serif;

  .wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    .top-bar {
      display: flex;
      align-items: center;
      margin: $bb-spacing-5 $bb-spacing-6 $bb-spacing-4;

      .search {
        flex-grow: 1;
        margin-right: $bb-spacing-7;
      }
    }

    .main-content {
      padding: 0 $bb-spacing-3;
    }
  }
}

.loading-spinner {
  width: 100vw;
  height: 100vh;
}
</style>
